export const UserRoutes = {
  PageIndex: '/users',
  UserDetail: '/users/:id',
  UsersList: '/users/list',
} as const;
